import React, { useEffect, useState, useContext } from 'react';

import { ResponsiveHeader } from '../responsive-header/ResponsiveHeader';

import { SkipLinks } from '../link-list/SkipLinks';
import { skipLinks } from '../links';
import { authenticateUser } from '../../../client/authenticate-user';
import { Navigation } from '../navigation/Navigation';
import styles from './header-wrapper.scss';
import { UserContext } from '../../scaffold/UserContext';
import { getUserProfile } from '../../../client/getUserProfile';

interface HeaderWrapperProps {
  features: Features;
}

export const HeaderWrapper = ({ features }: HeaderWrapperProps) => {
  const [mobileNavShown, setMobileNavShown] = useState<boolean>(false);
  const [typeaheadIsOpen, setTypeaheadIsOpen] = useState<boolean>(false);

  const { updateUserState } = useContext(UserContext) as any;

  useEffect(function initUserState() {
    if (features.authenticationEnabled) {
      authenticateUser(updateUserState);
    } else if (!features.authenticationEnabled) {
      const userProfile = getUserProfile();
      updateUserState(userProfile);
    }
  }, []);

  /* temporary requirement to allow both standard and premium to set global css values without conflicting with each other */
  useEffect(function setPremiumHeaderHtmlClass() {
    document.documentElement.classList.add('jl-premium-header');
    return () => document.documentElement.classList.remove('jl-premium-header');
  }, []);

  return (
    <header className={styles.siteWide} data-testid="premium-header-wrapper">
      <div className={styles.headerContainer}>
        <SkipLinks links={skipLinks} />
        <ResponsiveHeader
          updateMobileNavState={setMobileNavShown}
          updateTypeaheadState={setTypeaheadIsOpen}
        >
          <Navigation
            mobileNavShown={mobileNavShown}
            typeaheadIsOpen={typeaheadIsOpen}
          />
        </ResponsiveHeader>
      </div>
    </header>
  );
};
